export const clickEvents = (eventLabel: string, eventName: string, cdSection: string) => {
  window.dataLayer.push({
    event: 'analytics-event',
    event_parameters: {
      event_name: eventName,
      cd_interaction_detail: eventLabel,
      cd_section: cdSection,
    },
  });
};
